import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useMatches } from 'react-router-dom';
import CookieNotificationBanner from './components/notification-banners/CookieNotificationBanner';
import LoginNotificationBanner from './components/notification-banners/LoginNotificationBanner';
import OldBrowserNotificationBanner from './components/notification-banners/OldBrowserNotificationBanner';
import useTermsOfUse from './components/terms-of-use/hooks/useTermsOfUse';
import FeatureTogglesContext from './contexts/FeatureTogglesContext';
import useGoogleAnalyticsRole from './hooks/useGoogleAnalyticsRole';
import SmsSyncNotificationBanner from './components/notification-banners/SmsSyncNotificationBanner';

import 'react-date-range/dist/styles.css';
import './scss/index.scss';
import '@pelckmans/business-components/css/business-components.css';
import '@pelckmans/business-components/css/business-components-modules.css';
import './scss/business-components.scss';

function checkFlagForRouteHandle(matches: ReturnType<typeof useMatches>, propertyName: string) {
  return matches.some(x => {
    return (
      typeof x.handle === 'object' &&
      x.handle &&
      propertyName in x.handle &&
      (x.handle as Record<string, unknown>)[propertyName] === true
    );
  });
}

export default function AppLayout() {
  const { t } = useTranslation();
  const featureToggles = useContext(FeatureTogglesContext);

  useGoogleAnalyticsRole();
  useTermsOfUse();

  useEffect(() => {
    window.loadingScreen?.finish();
  }, []);

  const matches = useMatches();

  if (Object.keys(featureToggles).length === 0) return null;

  return (
    <div className={classNames('app', { material: checkFlagForRouteHandle(matches, 'isMaterial') })}>
      <div className="notification-banners">
        <CookieNotificationBanner />
        <OldBrowserNotificationBanner />
        <SmsSyncNotificationBanner />
        {checkFlagForRouteHandle(matches, 'includeLoginNotificationBanner') && <LoginNotificationBanner />}
      </div>

      <Outlet />

      <footer className="footer">
        <p>
          <small className="credits">{t('CREDITS')}</small>
        </p>
      </footer>
    </div>
  );
}
